import React, { useContext, useState } from "react";
import { userContext } from "../context/UserContext";
import { useNavigate } from "react-router-dom";
import DashboardSideBar from "../component/DashboardSideBar";
import { api_url } from "../helpers";

const DashBoard = () => {
  const { user, setUser, setLoad } = useContext(userContext);
  const navigate = useNavigate();
  const [FirstName, setFirstName] = useState("");
  const [SecondName, setSecondName] = useState("");
  const [Email, setEmail] = useState("");
  const [Phone, setPhone] = useState("");
  const [CurrentPassword, setCurrentPassword] = useState("");
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");

  // prevent page reload
  async function MyProfile(e) {
    e.preventDefault();

    setLoad(true);

    //form data
    const MyProfileData = new FormData();

    const responseData = await fetch(api_url + "", {
      headers: {
        Authorization: `token ${user?.api_key}:${user?.api_secret}`,
      },
      method: "POST",
      body: MyProfileData,
    });

    setTimeout(() => {
      setLoad(false);
    }, 300);
  }

  return (
    <section>
      <div className="container UserDetails-custom">
        <div className="row">
          <DashboardSideBar
            currentPage="My Profile"
            navigate={navigate}
            setUser={setUser}
          />

          <div className="col-lg-9 mt-24">
            <form
              className="g-3 DashBoard-right-side-form-1 mx-1"
              onSubmit={(e) => MyProfile(e)}
            >
              <div>
                <h6 className="ps-12">ACCOUNT SETTING</h6>
              </div>
              <hr className="p-0 m-0" />
              <div className="row px-30">
                <div className="col-md-6 mt-20">
                  <label for="text" className="form-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputText4"
                    placeholder="John"
                    value={FirstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
                <div className="col-md-6 mt-20">
                  <label for="inputPassword4" className="form-label">
                    Second Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputText4"
                    placeholder="Doe"
                    value={SecondName}
                    onChange={(e) => setSecondName(e.target.value)}
                  />
                </div>

                <div className="col-md-6 mt-20">
                  <label for="inputEmail4" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="inputEmail4"
                    placeholder="JohnDoe@gmail.com"
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="col-md-6 mt-20">
                  <label for="inputNumber4" className="form-label">
                    Phone
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="inputPassword4"
                    placeholder="+91 XXXXXXXXXX"
                    value={Phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-12 px-30">
                <button
                  type="submit"
                  className="btn btn-main d-inline-flex align-items-center gap-8 mt-24"
                >
                  SAVE CHANGES
                </button>
              </div>
            </form>

            <form
              className="my-60 mx-1 row DashBoard-right-side-form-2"
              onSubmit={(e) => MyProfile(e)}
            >
              <div>
                <h6>CHANGE PASSWORD</h6>
              </div>
              <hr />
              <div className="col-md-12 mb-24 px-30 ">
                <label for="text" className="form-label">
                  Current Password
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="inputText4"
                  placeholder="Current Password"
                  value={CurrentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  required
                />
              </div>
              <div className="col-md-12 mb-24 px-30">
                <label for="inputPassword4" className="form-label">
                  New Password
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="inputText4"
                  placeholder="New Password"
                  value={NewPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </div>
              <div className="col-md-12 px-30">
                <label for="inputPassword4" className="form-label">
                  Confirm Password
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="inputText4"
                  placeholder="Confirm Password"
                  value={ConfirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
              <div className="col-12 mt-18 px-30">
                <button
                  type="submit"
                  className="btn btn-main d-inline-flex align-items-center gap-8 mt-24"
                >
                  CHANGE PASSWORD
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DashBoard;
